import React, { useContext, useEffect, useState } from 'react';
import { DndProvider, DropTargetMonitor, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import AddSetItemModal from '../../../components/modal/AddSetItemModal';
import ProductController, {
  CategoryType,
  ProductBadgeType,
  SetCategoryType,
  SetItemProductType,
  SetMenuItemType,
  SetMenuType,
} from '../../../controller/ProductController';
import UtilController from '../../../controller/UtilController';
import { AuthContext } from '../../../navigation/AuthProvider';
import { getNumberToString } from '../../../utils/util';
import { useToast } from '../../../controller/ToastController';
import { SelectType } from '../../../components/DropdownSelect';
import ConfirmModal from '../../../components/modal/ConfirmModal';
import { CurrentStoreContext } from '../../../controller/StoreController';

const SetMenuEdit = () => {
  const showToast = useToast();
  const navigate = useNavigate();
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const location = useLocation();
  const setMenuInfo: SetMenuType = location.state?.setMenuInfo;

  const [name, setName] = useState<string>('');
  const [price, setPrice] = useState<string>('');
  const [discountPrice, setDiscountPrice] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [discountPercent, setDiscountPercent] = useState<number>(0);
  const [productMediaId, setProductMediaId] = useState<number | null>(null);
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [categorys, setCategorys] = useState<SelectType[]>([]);
  const [setItems, setSetItems] = useState<SelectType[]>([]);
  const [optionalItems, setOptionalItems] = useState<SelectType[]>([]);

  const [categoryList, setCategoryList] = useState<SelectType[]>([]);
  const [setItemList, setSetItemList] = useState<SelectType[]>([]);
  const [optionalItemList, setOptionalItemList] = useState<SelectType[]>([]);

  const [badgeType, setBadgeType] = useState<number>(-1);
  const [badgeList, setBadgeList] = useState<ProductBadgeType[]>([]);

  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);
  const [visibleNavigate, setVisibleNavigate] = useState<boolean>(false);

  const navigateProductEdit = () => {
    navigate(`/product/setitem/edit`);
    setVisibleNavigate(false);
  };

  const onChange_name = (event: any) => {
    setName(event.target.value);
  };
  const onChange_price = (event: any) => {
    setPrice(getNumberToString(event.target.value));
    setDiscountPrice(getNumberToString(event.target.value));
  };
  const onChange_discount = (event: any) => {
    setDiscountPrice(getNumberToString(event.target.value));
  };
  const onChange_description = (event: any) => {
    setDescription(event.target.value);
  };

  const onChange_badgeType = (value: number) => {
    if (badgeType === value) {
      setBadgeType(-1);
    } else setBadgeType(value);
  };

  const deleteImage = () => {
    setImageUrl(null);
    setProductMediaId(null);
  };

  // 이미지 등록
  const productUploadImage = async (e: any) => {
    console.log('files', e.target.files);
    let origin = e.target.files[0];
    if (origin !== undefined) {
      if (origin.type !== undefined && origin.type !== null) {
        if (origin.type === 'image/png' || origin.type === 'image/jpeg') {
          const formData = new FormData();
          formData.append('file', origin);
          const oRes = await UtilController.productUploadImg(formData, currentStore.value);
          console.log('productUploadImage', oRes);
          if (oRes.data) {
            const oResponse = oRes.data;
            if (oResponse.ok && oResponse.data) {
              setImageUrl(oResponse.data.url_path);
              setProductMediaId(oResponse.data.product_media_id);
            } else {
              showToast('파일 이름이 너무 길거나 형식에 맞지 않아요', 'error');
            }
          }
          return;
        }
      }
    }
  };

  // API 호출
  const getCategoryData = async () => {
    try {
      const oRes = await ProductController.getAllCateProduct(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getCategoryData', oResponse);
        if (oResponse.data) {
          let updatedList: any = [];
          oResponse.data.map((item: CategoryType, index: number) => {
            updatedList.push({
              key: index,
              value: { id: item.category_id, is_for_adult: item.is_for_adult },
              name: item.category_name,
              label: item.category_name,
            });
          });
          setCategoryList([...updatedList]);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const getProductBadge = async () => {
    try {
      const oRes = await ProductController.getBadge(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getBadge', oResponse);
        if (oResponse.data) {
          setBadgeList([...oResponse.data]);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const getSetProductData = async () => {
    try {
      const oRes = await ProductController.getAllSetPrdGroup(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getAllSetPrdGroup', oResponse);
        if (oResponse.data) {
          let updatedSetItemList: any = [];
          let updatedOptionalItemList: any = [];
          oResponse.data.map((item: SetMenuItemType, index: number) => {
            if (item.input_min === 0)
              updatedOptionalItemList.push({
                key: index,
                value: item.set_type_id,
                name: item.set_type_name,
                label: item.set_type_name,
              });
            else
              updatedSetItemList.push({
                key: index,
                value: item.set_type_id,
                name: item.set_type_name,
                label: item.set_type_name,
              });
          });
          setSetItemList([...updatedSetItemList]);
          setOptionalItemList([...updatedOptionalItemList]);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const setSetMenuData = async () => {
    try {
      if (checkRequired()) {
        const categoryTemp: any = [];
        categorys.map((item: SelectType) => {
          categoryTemp.push({ category_id: item.value.id });
        });
        const setItemTemp: any = [];
        setItems.map((item: SelectType) => {
          setItemTemp.push({ set_type_id: item.value });
        });
        optionalItems.map((item: SelectType) => {
          setItemTemp.push({ set_type_id: item.value });
        });

        if (setMenuInfo) {
          const setMenu = {
            set_product_id: setMenuInfo.set_prd_id,
            name: name,
            description: description,
            base_price: discountPrice === '' ? parseInt(price) : parseInt(discountPrice),
            org_price: parseInt(price),
            product_media_id: productMediaId,
            category_list: categoryTemp,
            set_prd_type_list: setItemTemp,
            option_group_list: [],
            badge_list: [{ badge_id: badgeType }],
          };
          const oRes = await ProductController.editSetProduct(currentStore.value, setMenu);
          if (oRes && oRes.data) {
            const oResponse = oRes.data;
            console.log('editSetProduct', oResponse);
            if (oResponse.data && oResponse.ok) {
              console.log(setMenu);
              showToast('세트 상품 정보를 수정했어요');
            }
          }
        } else {
          const setMenu = {
            name: name,
            description: description,
            base_price: discountPrice === '' ? parseInt(price) : parseInt(discountPrice),
            org_price: parseInt(price),
            product_media_id: productMediaId,
            category_list: categoryTemp,
            set_prd_type_list: setItemTemp,
            option_group_list: [],
            badge_list: [{ badge_id: badgeType }],
          };
          const oRes = await ProductController.setSetProduct(currentStore.value, setMenu);
          if (oRes && oRes.data) {
            const oResponse = oRes.data;
            console.log('setSetProduct', oResponse);
            if (oResponse.data && oResponse.ok) {
              console.log(setMenu);
              showToast('새로운 세트 상품 정보를 등록했어요');
              onChange_badgeType(-1);
              setSetItems([]);
              setOptionalItems([]);
            }
          }
        }
      } else {
        showToast('필수 정보를 입력해주세요', 'error');
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const deleteSetMenuData = async () => {
    try {
      const oRes = await ProductController.delProduct(setMenuInfo.set_prd_id, 1);
      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('delProduct', oResponse);
        if (oResponse.data && oResponse.ok) {
          showToast('세트 상품을 삭제했어요');
          navigate(-1);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  // 필수 확인
  const checkRequired = () => {
    if (name.length > 0 && categorys.length > 0 && price.length > 0 && setItems.length > 0)
      return true;
    return false;
  };

  useEffect(() => {
    if (price === '' || discountPrice === '') setDiscountPercent(0);
    else
      setDiscountPercent(
        parseFloat(
          (((parseInt(price) - parseInt(discountPrice)) * 100) / parseInt(price)).toFixed(1),
        ),
      );
  }, [price, discountPrice]);

  useEffect(() => {
    getCategoryData();
    getProductBadge();
    getSetProductData();

    if (setMenuInfo) {
      setName(setMenuInfo.set_prd_name);
      setDescription(setMenuInfo.set_prd_description);
      setPrice(setMenuInfo.set_org_price.toString());
      setDiscountPrice(setMenuInfo.set_base_price.toString());
      setImageUrl(setMenuInfo.url_path);
      setBadgeType(setMenuInfo.badge_list.length > 0 ? setMenuInfo.badge_list[0].badge_id : -1);

      let setItemTemp: SelectType[] = [];
      let optionalItemTemp: SelectType[] = [];
      setMenuInfo.set_prd_type_list.map((item: SetMenuItemType, index: number) => {
        if (item.input_min === 0)
          optionalItemTemp.push({
            key: index,
            value: item.set_type_id,
            name: item.set_type_name,
            label: item.set_type_name,
          });
        else
          setItemTemp.push({
            key: index,
            value: item.set_type_id,
            name: item.set_type_name,
            label: item.set_type_name,
          });
      });
      setSetItems([...setItemTemp]);
      setOptionalItems([...optionalItemTemp]);

      let categoryTemp: SelectType[] = [];
      setMenuInfo.category_list.map((item: SetCategoryType, index: number) => {
        categoryTemp.push({
          key: index,
          value: { id: item.category_id, is_for_adult: item.is_for_adult },
          name: item.name,
          label: item.name,
        });
      });
      setCategorys([...categoryTemp]);
      // console.log(setMenuInfo, setItems, optionalItems);
    }

    // getCategoryData();
    // getProductOptionData();
  }, []);

  const handleCategoryClick = (item: any) => {
    if (!categorys.some((category: any) => category.value === item.value)) {
      setCategorys([...categorys, item]);
    }
  };
  const handleSetItemClick = (item: any) => {
    if (!setItems.some((setItem: any) => setItem.value === item.value)) {
      setSetItems([...setItems, item]);
    }
  };
  const handleOptionalItemClick = (item: any) => {
    if (!optionalItems.some((optionItem: any) => optionItem.value === item.value)) {
      setOptionalItems([...optionalItems, item]);
    }
  };

  // custom dropdown
  const RenderCustomDropdown = (oProps: { data: any; title: string; handleOnClick: any }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleSelectClick = () => {
      setIsOpen(!isOpen);
    };

    return (
      <div className="customSelect">
        <div className="customSelectHeader" onClick={handleSelectClick}>
          {oProps.title}
          <img
            src={`${process.env.PUBLIC_URL}/svg/ic_arrow_down_grey.svg`}
            width={20}
            height={20}
            alt="ic"
          />
        </div>
        {isOpen && (
          <ul
            className="customSelectList"
            style={{ height: `${oProps.data.length > 6 ? 200 : oProps.data.length * 32}px` }}>
            {oProps.data.map((item: any) => (
              <li
                key={item.key}
                onClick={() => {
                  oProps.handleOnClick(item);
                  setIsOpen(false);
                }}
                className="customSelectItem">
                {item.name}
                {item.value.is_for_adult ? (
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_adult.svg`}
                    alt="ic"
                    width={16}
                    height={16}
                  />
                ) : (
                  <div />
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  interface DraggableItemProps {
    item: SelectType;
    index: number;
    itemList: SelectType[];
    setItem: any;
    type: number;
    moveItem: (fromIndex: number, toIndex: number, item: any, setItem: any) => void;
  }

  const moveItem = (fromIndex: number, toIndex: number, item: any, setItem: any) => {
    if (toIndex < 1) toIndex = 0;
    else if (toIndex > item.length - 1) toIndex = item.length;
    const newItems = [...item];
    const [movedItem] = newItems.splice(fromIndex, 1);
    newItems.splice(toIndex, 0, movedItem);
    setItem(newItems);
  };
  const deleteItem = (index: number, item: any, setItem: any) => {
    item.splice(index, 1);
    setItem([...item]);
  };

  const RenderDraggableItem = ({
    item,
    index,
    itemList,
    setItem,
    type,
    moveItem,
  }: DraggableItemProps) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(index + 1);

    const [, categoryDrag] = useDrag({
      type: 'ITEM',
      item: { item, index },
    });
    const [, categoryDrop] = useDrop({
      accept: 'ITEM',
      hover: (item: { index: number }, monitor: DropTargetMonitor) => {
        if (item.index !== index) {
          moveItem(item.index, index, categorys, setCategorys);
          item.index = index;
        }
      },
    });

    const [, setItemDrag] = useDrag({
      type: 'ITEM',
      item: { item, index },
    });
    const [, setItemDrop] = useDrop({
      accept: 'ITEM',
      hover: (item: { index: number }, monitor: DropTargetMonitor) => {
        if (item.index !== index) {
          moveItem(item.index, index, itemList, setItem);
          item.index = index;
        }
      },
    });

    const [, optionItemDrag] = useDrag({
      type: 'ITEM',
      item: { item, index },
    });
    const [, optionItemDrop] = useDrop({
      accept: 'ITEM',
      hover: (item: { index: number }, monitor: DropTargetMonitor) => {
        if (item.index !== index) {
          moveItem(item.index, index, itemList, setItem);
          item.index = index;
        }
      },
    });

    return (
      <div className="optionItem" key={index}>
        <div className="row gap">
          <input
            ref={(node) =>
              type === 0
                ? categoryDrag(categoryDrop(node))
                : type === 1
                ? setItemDrag(setItemDrop(node))
                : optionItemDrag(optionItemDrop(node))
            }
            value={selectedIndex}
            autoFocus={false}
            className="indexInput"
            onChange={(e) => {
              setSelectedIndex(Number(e.target.value));
            }}
            onBlur={() => {
              moveItem(index, selectedIndex - 1, itemList, setItem);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                moveItem(index, selectedIndex - 1, itemList, setItem);
              }
            }}
          />
          <div className="row">
            <h4>{item.name}</h4>
            {item.value.is_for_adult ? (
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_adult.svg`}
                alt="ic"
                width={22}
                height={22}
              />
            ) : (
              <div />
            )}
          </div>
        </div>
        <div className="deleteBox" onClick={() => deleteItem(index, itemList, setItem)}>
          <h5>삭제</h5>
        </div>
      </div>
    );
  };

  return (
    <>
      {' '}
      <Style>
        <div className="contentContainer">
          <div className="editHeaderWrap">
            <button className="backButton" onClick={() => navigate(-1)}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_left.svg`} alt="ic" />
            </button>
            <button className="deleteButton" onClick={() => setVisibleConfirm(true)}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_trashcan_green.svg`} alt="ic" />
              <h5>메뉴삭제</h5>
            </button>
          </div>
          <div className="inputText">
            <div className="title">
              <h4>상품분류</h4>
              <h5>(필수)</h5>
            </div>
            <RenderCustomDropdown
              data={categoryList}
              title="카테고리를 선택해주세요"
              handleOnClick={handleCategoryClick}
            />
            {categorys.length > 0 && (
              <div className="optionList">
                <DndProvider backend={HTML5Backend}>
                  {categorys.map((item: SelectType, index: number) => (
                    <div className="optionItem" key={index}>
                      <div className="row gap">
                        <div className="indexInput">{index + 1}</div>
                        <div className="row">
                          <h4>{item.name}</h4>
                          {item.value.is_for_adult ? (
                            <img
                              src={`${process.env.PUBLIC_URL}/svg/ic_adult.svg`}
                              alt="ic"
                              width={22}
                              height={22}
                            />
                          ) : (
                            <div />
                          )}
                        </div>
                      </div>
                      <div
                        className="deleteBox"
                        onClick={() => deleteItem(index, categorys, setCategorys)}>
                        <h5>삭제</h5>
                      </div>
                    </div>
                  ))}
                </DndProvider>
              </div>
            )}
            <div className="warningSign">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
              <p>하나의 상품을 여러개의 상품분류에 등록하실 수 있습니다</p>
            </div>
          </div>
          <div className="inputText">
            <div className="title">
              <h4>세트메뉴명</h4>
              <h5>(필수)</h5>
            </div>
            <input
              type="text"
              placeholder="세트메뉴명을 적어주세요"
              value={name}
              onChange={onChange_name}
              autoFocus={true}
            />
          </div>
          <div className="inputText">
            <div className="title">
              <h4>세트메뉴 가격</h4>
              <h5>(필수)</h5>
            </div>
            <div className="inputWrap">
              <div className="unit">원</div>
              <input
                type="text"
                value={price}
                placeholder="0"
                onChange={onChange_price}
                autoFocus={false}
              />
            </div>
          </div>
          <div className="inputText">
            <div className="title">
              <h4>최종 판매가격</h4>
              <h5 className="grey">(할인된 금액을 입력해주세요)</h5>
            </div>
            <div className="discountWrap">
              <div className="inputWrap price">
                <div className="unit">원</div>
                <input
                  type="text"
                  value={discountPrice}
                  placeholder={'(선택) 할인된 최종 판매가격'}
                  onChange={onChange_discount}
                  autoFocus={false}
                />
              </div>
              <div className="inputWrap discount">
                <h4>할인율</h4>
                <h3>{discountPercent}%</h3>
              </div>
            </div>
          </div>
          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
            <div>
              <p>
                할인된 최종 판매가격 입력시 기기에 원래 가격, 할인 판매가격, 할인율이 표시되며,
                결제할때 최종 판매가격입니다.
              </p>
              <p>
                할인된 가격을 입력하시면, 기기상에 할인율이 강조 표시되며, 고객의 주문을 유도할 수
                있습니다.
              </p>
            </div>
          </div>
          <div className="inputText">
            <div className="title">
              <h4>이미지</h4>
              <h5 className="imageSpan">권장사이즈: 800 x 680</h5>
            </div>
            <div className="row gap">
              <input
                id={`setImage`}
                type="file"
                name="photo"
                accept="image/*"
                autoFocus={false}
                onChange={productUploadImage}
              />
              {imageUrl === '' || imageUrl === null ? (
                <label className="photoBox" htmlFor={`setImage`}>
                  <img src={`${process.env.PUBLIC_URL}/svg/ic_photo.svg`} alt="ic" />
                  <h5>이미지 추가</h5>
                </label>
              ) : (
                <img className="previewImg" src={imageUrl} alt="img" />
              )}
              {imageUrl !== '' && imageUrl !== null && (
                <>
                  <label className="imageButton edit" htmlFor={`setImage`}>
                    수정
                  </label>
                  <button className="imageButton delete" onClick={deleteImage}>
                    삭제
                  </button>
                </>
              )}
            </div>
          </div>
          <div className="inputText">
            <div className="title">
              <h4>설명</h4>
            </div>
            <textarea
              placeholder="메뉴에 관한 설명을 적어주세요"
              value={description}
              onChange={onChange_description}
              autoFocus={false}
            />
          </div>
          <div className="inputText">
            <div className="title">
              <div>
                <h4>상품 추천</h4>
                <div className="warningSign">
                  <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
                  <p>고객님께 추천하고 싶은 상품에 표시됩니다.</p>
                </div>
              </div>
            </div>
            <div className="selectBoxWrap">
              {badgeList.map((item: ProductBadgeType, index: number) => {
                return (
                  <div
                    key={index}
                    className={`selectBox ${badgeType === item.badge_id && 'active'} ${
                      index === 0 && 'left'
                    } ${index === badgeList.length - 1 && 'right'}`}
                    onClick={() => onChange_badgeType(item.badge_id)}>
                    {item.badge_name}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="contentContainer">
          <div className="inputText">
            <div className="title initial">
              <h4>세트구성 메뉴</h4>
              <h5>(필수)</h5>
            </div>

            <div className="warningSign">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
              <p>무조건 선택해야하는 옵션입니다</p>
            </div>
            <RenderCustomDropdown
              data={setItemList}
              title="세트메뉴를 선택해주세요"
              handleOnClick={handleSetItemClick}
            />
            {setItems.length > 0 && (
              <div className="optionList">
                <DndProvider backend={HTML5Backend}>
                  {setItems.map((item: SelectType, index: number) => {
                    return (
                      <RenderDraggableItem
                        key={index}
                        item={item}
                        index={index}
                        itemList={setItems}
                        setItem={setSetItems}
                        type={1}
                        moveItem={moveItem}
                      />
                    );
                  })}
                </DndProvider>
              </div>
            )}
          </div>
          <div className="inputText">
            <div className="title">
              <h4>추가구성 메뉴</h4>
            </div>
            <div className="warningSign">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
              <p>옵션 선택은 필수가 아닙니다. ex)곁들이기 좋은 메뉴</p>
            </div>
            <RenderCustomDropdown
              data={optionalItemList}
              title="옵션메뉴를 선택해주세요"
              handleOnClick={handleOptionalItemClick}
            />
            {optionalItems.length > 0 && (
              <div className="optionList">
                <DndProvider backend={HTML5Backend}>
                  {optionalItems.map((item: SelectType, index: number) => {
                    return (
                      <RenderDraggableItem
                        key={index}
                        item={item}
                        index={index}
                        itemList={optionalItems}
                        setItem={setOptionalItems}
                        type={2}
                        moveItem={moveItem}
                      />
                    );
                  })}
                </DndProvider>
              </div>
            )}
          </div>
          <button className="addButton" onClick={() => setVisibleNavigate(true)}>
            <h5>세트구성 만들러 가기</h5>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_right_green.svg`} alt="ic" />
          </button>
          <button
            className={`submitButton ${!checkRequired() && 'inactive'}`}
            onClick={setSetMenuData}>
            저장
          </button>
        </div>
      </Style>
      <ConfirmModal
        isOpen={visibleConfirm}
        title={`삭제 후 복구할 수 없습니다.\n정말 삭제하시겠어요?`}
        onCancelText="취소"
        onConfirmText="삭제"
        onCancel={() => setVisibleConfirm(false)}
        onConfirm={deleteSetMenuData}
      />
      <ConfirmModal
        isOpen={visibleNavigate}
        title={`세트구성 등록 페이지로 이동하면\n변경사항이 저장되지 않아요.\n저장하지 않고 이동할까요?`}
        onCancelText="취소"
        onConfirmText="이동"
        onCancel={() => setVisibleNavigate(false)}
        onConfirm={navigateProductEdit}
      />
    </>
  );
};

export default SetMenuEdit;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0 0 10px 10px;
  }

  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .addButton {
    width: 100%;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    margin-top: 16px;
    h5 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  .editHeaderWrap {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .deleteButton {
      display: flex;
      align-items: center;
      padding: 6px 10px;
      border: 1px solid #40977f;
      border-radius: 5px;
      gap: 10px;
      h5 {
        color: #40977f;
      }
    }
  }

  .inputText {
    .row.gap {
      gap: 10px;
      align-items: flex-end;
    }

    img {
      cursor: pointer;
    }

    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 6px;

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      .imageSpan {
        color: #979797;
        font-weight: 400;
      }
      h4 {
        color: #555555;
      }
      .grey {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }

    .inputWrap {
      position: relative;
      .unit {
        position: absolute;
        font-size: 16px;
        line-height: 22px;
        color: #a7a7a7;
        top: 50%;
        transform: translateY(-50%);
        right: 20px;
      }
    }

    .discountWrap {
      display: flex;
      align-items: center;
      gap: 10px;
      .inputWrap.price {
        width: 100%;
        flex: 70% 0 0;
      }
      .inputWrap.discount {
        width: 100%;
        flex: 1;
        padding: 5px 20px;
        border: 1px solid #cecece;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        h3 {
          font-size: 20px;
          line-height: 28px;
          font-weight: 600;
          color: #555555;
        }
        h4 {
          font-size: 16px;
          line-height: 22px;
          font-weight: 400;
          color: #555555;
        }
      }
    }
  }

  input,
  textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #cecece;
    border-radius: 5px;
    color: #555555;
  }

  textarea {
    min-height: 100px;
  }

  input::placeholder,
  textarea::placeholder {
    color: #cecece;
  }

  .optionList {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #cecece;
    border-radius: 5px;
    margin-top: 12px;
  }
  .optionItem {
    width: 100%;
    padding: 6px 20px 6px 30px;
    border-radius: 5px;
    border-bottom: 1px solid #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .row {
      gap: 8px;
    }
    .row.gap {
      gap: 16px;
    }
    .indexInput {
      width: 24px;
      height: 24px;
      padding: 2px;
      font-size: 16px;
      line-height: 20px;
      font-weight: 600;
      color: #555555;
      background: #ffffff;
      border: 1px solid #4dd2ae;
      text-align: center;
      border-radius: 3px;
    }
    h4 {
      font-size: 18px;
      line-height: 24px;
      color: #555555;
      font-weight: 500;
    }
    .deleteBox {
      border: 1px solid #4dd2ae;
      border-radius: 5px;
      padding: 4px 12px;
      text-align: center;
      cursor: pointer;
      h5 {
        font-size: 14px;
        line-height: 20px;
        color: #4dd2ae;
        font-weight: 500;
      }
    }
  }

  .previewImg {
    width: 120px;
    height: 102px;
    border-radius: 5px;
    border: 1px solid #cecece;
    object-fit: cover;
  }
  .photoBox {
    width: 120px;
    height: 102px;
    border-radius: 5px;
    padding: 14px;
    padding-top: 20px;
    border: 1px solid #cecece;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    h5 {
      color: #a7a7a7;
      font-weight: 400;
    }
    .productImg {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  input[type='file'] {
    display: none;
  }

  .imageButton {
    background: #ffffff;
    text-align: center;
    border-radius: 5px;
    padding: 6px 14px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    cursor: pointer;
  }
  .imageButton.edit {
    border: 1px solid #cecece;
    color: #555555;
  }
  .imageButton.delete {
    border: 1px solid #4dd2ae;
    color: #4dd2ae;
  }

  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .customSelect {
    position: relative;
    flex: 1;
    padding: 8px 12px;
    font-size: 16px;
    line-height: 20px;
    color: #979797;
    border: 1px solid #cecece;
    border-radius: 5px;
  }
  .customSelectHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .customArrow {
    color: #979797;
  }
  .customArrow.open {
    color: #555555;
    font-weight: 600;
  }

  .customSelectList {
    width: 100%;
    position: absolute;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1;
    top: 19px;
    left: 0;
    padding: 2px 0;
    border-radius: 0px 0px 5px 5px;
    background: #ffffff;
    border: 1px solid #cecece;
    list-style: none;
    animation: expandDown 0.15s ease-out;

    .customSelectItem {
      display: flex;
      align-items: center;
      padding: 6px 12px 6px 17px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      gap: 4px;
    }
    .customSelectItem:hover {
      background: #ecf5f3;
    }
  }

  .selectBoxWrap {
    display: flex;
    align-items: center;
    padding-bottom: 20px;

    .selectBox {
      flex: 1;
      border: 1px solid #cecece;
      background: #ffffff;
      font-size: 14px;
      line-height: 20px;
      color: #555555;
      padding: 8px 0;
      text-align: center;
      cursor: pointer;
    }
    .selectBox.left {
      border-radius: 5px 0px 0px 5px;
      border-right: none;
    }
    .selectBox.right {
      border-radius: 0px 5px 5px 0px;
      border-left: none;
    }
    .selectBox.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
    }
  }

  @media (max-width: 600px) {
    .discountWrap {
      flex-direction: column;
    }
    .customSelect {
      padding: 8px 5px 8px 10px;
      font-size: 12px;
    }
    .customSelectList {
      .customSelectItem {
        padding: 6px 8px;
        font-size: 12px;
      }
    }
  }
`;
